<template>
  <el-row :gutter="10">
    <el-col :span="14">
      <page-main
        ref="pageMain"
        :tableData="tableData"
        :disabled="disabled"
        :loading="loading"
        :changeOrderCode="changeOrderCode"
        @openEditDialog="openEditDialog"
        @reload="getData"
      >
      </page-main>
    </el-col>
    <el-col :span="10">
      <DocTable :changeOrderCode="changeOrderCode" :disabled="disabled" />
    </el-col>
    <EditFromDialog
      ref="editFrom"
      @reload="getData"
      :visible.sync="goodsDetailDialogParams.visible"
      :disabled="goodsDetailDialogParams.disabled"
      :title="goodsDetailDialogParams.title"
      :changeOrderCode="changeOrderCode"
      :orderInspectionCode="goodsDetailDialogParams.orderInspectionCode"
      :changeOrderInspectionCode="goodsDetailDialogParams.changeOrderInspectionCode"
      :copyDisabled="goodsDetailDialogParams.copyDisabled"
    />
  </el-row>
</template>
<script>
import PageMain from './main'
import EditFromDialog from '../edit-from/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
import DocTable from '../doc-table'
export default {
  mixins: [EditLoading],
  props: {
    changeOrderCode: String,
    disabled: { type: Boolean, default: false },
  },
  components: { PageMain, EditFromDialog, DocTable },
  data() {
    return {
      tableData: [],
      loading: false,
      goodsDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
        copyDisabled: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderCode) return
      this.loading = true
      this.$api
        .changeOrderInspectionListApi({ changeOrderCode: this.changeOrderCode })
        .then((res) => {
          this.tableData = res.body.data
          this.loading = false
        })
    },
    openEditDialog({ type, code = '' }) {
      const types = {
        add: this.$l('dialog_title_inspection_add') || '添加验货要求',
        edit: this.$l('dialog_title_inspection_edit') || '编辑验货要求',
        detail: this.$l('dialog_title_inspection_detail') || '查看验货要求',
        copy: this.$l('dialog_title_inspection_copy') || '复制验货要求',
      }
      this.goodsDetailDialogParams = {
        visible: true,
        title: types[type],
        orderInspectionCode: code.orderInspectionCode,
        changeOrderInspectionCode: code.changeOrderInspectionCode,
        disabled: type === 'detail',
        copyDisabled: type === 'copy',
      }
    },
  },
}
</script>
